import TechnologyBanner from './TechnologyBanner';
import TechnologySection from './TechnologySection';

function Technology() {
  return (
    <div>
      <TechnologyBanner />
      <TechnologySection />
    </div>
  );
}

export default Technology;